import { BaseEdge, getBezierPath } from '@xyflow/react';
import React, { useContext } from 'react';
import { useTheme } from '@mui/material';

import { ScenarioDiagramContext } from '../../../state/Context';

import EdgeMarker from './EdgeMarker';

function JourneyEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data: { patientCategory },
}) {
  const theme = useTheme();
  const {
    state: { activePatientCategory },
  } = useContext(ScenarioDiagramContext);
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const active = activePatientCategory === patientCategory.id;
  const activeColor = theme.palette[active ? 'secondary' : 'primary'].main;
  const activeMarkerEnd = `marker-${activeColor}`;

  return (
    <>
      <EdgeMarker id={activeMarkerEnd} color={activeColor} />
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={`url(#${activeMarkerEnd})`}
        style={{ stroke: activeColor, ...style }}
      />
    </>
  );
}

export default JourneyEdge;
